export default "__VITE_ASSET__$eKJ$9vJ__"